import React from 'react';
import axios from 'axios';
import { Button } from '../ui/button';
import { Monitor, Trash2 } from 'lucide-react';
import { toast } from 'sonner';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export function DeviceManagementSection({ darkMode, devices, operatories, fetchData }) {
  const getOperatoryName = (operatoryId) => {
    const op = operatories.find(o => o.id === operatoryId);
    return op ? op.name : 'Unknown';
  };

  const handleUnregisterDevice = async (deviceId) => {
    try {
      await axios.delete(`${API}/devices/${deviceId}`);
      toast.success('Device unregistered');
      fetchData();
    } catch {
      toast.error('Failed to unregister device');
    }
  };

  return (
    <div className={`glass-panel rounded-2xl p-6 ${darkMode ? 'bg-slate-800/50' : ''}`}>
      <div className="flex items-center justify-between mb-6">
        <div>
          <h2 className={`text-xl font-heading font-bold flex items-center gap-2 ${darkMode ? 'text-slate-100' : 'text-slate-800'}`}>
            <Monitor className="w-5 h-5 text-emerald-600" />
            Registered Devices
          </h2>
          <p className={`text-sm mt-1 ${darkMode ? 'text-slate-400' : 'text-slate-500'}`}>
            Devices registered to specific operatories will automatically recognize their location
          </p>
        </div>
      </div>

      {devices.length === 0 ? (
        <div className={`text-center py-8 ${darkMode ? 'text-slate-400' : 'text-slate-500'}`}>
          <Monitor className={`w-12 h-12 mx-auto mb-3 ${darkMode ? 'text-slate-600' : 'text-slate-300'}`} />
          <p>No devices registered yet</p>
          <p className="text-sm mt-1">Register devices from the operatory dropdown on the dashboard</p>
        </div>
      ) : (
        <div className="space-y-3">
          {devices.map(device => (
            <div
              key={device.device_id}
              className={`flex items-center justify-between p-4 rounded-xl border ${
                darkMode ? 'border-slate-600 bg-slate-700/50' : 'border-slate-200 bg-white/50'
              }`}
            >
              <div className="flex items-center gap-4">
                <div className={`w-10 h-10 rounded-full flex items-center justify-center ${
                  darkMode ? 'bg-emerald-900/50' : 'bg-emerald-100'
                }`}>
                  <Monitor className="w-5 h-5 text-emerald-600" />
                </div>
                <div>
                  <p className={`font-medium ${darkMode ? 'text-slate-100' : 'text-slate-800'}`}>{device.device_name || 'Unknown Device'}</p>
                  <p className={`text-sm ${darkMode ? 'text-slate-400' : 'text-slate-500'}`}>
                    Registered to: <span className="font-medium text-emerald-600">{device.operatory_name || getOperatoryName(device.operatory_id)}</span>
                  </p>
                  <p className={`text-xs ${darkMode ? 'text-slate-500' : 'text-slate-400'}`}>
                    ID: {device.device_id.substring(0, 12)}...
                  </p>
                </div>
              </div>
              <Button
                variant="ghost"
                size="sm"
                onClick={() => handleUnregisterDevice(device.device_id)}
                className={`text-red-500 ${darkMode ? 'hover:text-red-400 hover:bg-red-900/30' : 'hover:text-red-700 hover:bg-red-50'}`}
              >
                <Trash2 className="w-4 h-4" />
              </Button>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
